import { render, staticRenderFns } from "./CustomerSpecificPricesAdd.vue?vue&type=template&id=200fad16"
import script from "./CustomerSpecificPricesAdd.vue?vue&type=script&lang=js"
export * from "./CustomerSpecificPricesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports